import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PopConfirmComponent } from '../../core/pop-confirm/pop-confirm.component';
import { NgForm } from '@angular/forms';
import { PickListHeader } from 'src/app/models/PickList/picklist-header';
import { PickListDetail } from 'src/app/models/PickList/picklist-detail';
import { PicklistService } from 'src/app/service/picklist.service';

@Component({
  selector: 'app-picklist-detail-form',
  templateUrl: './picklist-detail-form.component.html',
  styleUrls: ['./picklist-detail-form.component.scss'],
})
export class PickListDetailFormComponent implements OnInit {
  @Input() currentItem: PickListDetail;
  @Output() ShowForm = new EventEmitter<boolean>();

  @Output() submitEmitterCanCloseChildForm = new EventEmitter<any>(); //event permettant d'indiquer que l'enfant (ici) veut se fermer
  @Output() submitEmitterChildHaveChanges = new EventEmitter<any>(); //event permettant d'indiquer que l'enfant (ici) a des changemenets
  @Output() submitEmitterForceRefresh = new EventEmitter<any>();

  @ViewChild(NgForm) myform!: NgForm; //permet d'accéder ici (TS) au FORM fabriqué FrontEnd, nommé MyForm.

  titre: string;
  NomEntiteCourante: string = 'Picklist';
  IsChangesPublished: boolean = false;

  constructor(private dialog: MatDialog, private snack: MatSnackBar, private myMainService: PicklistService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    //on va essayer de ramasser le ID du projet par la route, si possible (en cas de pop-up, entre autre.. pas obligé)
    let MyPicklistIdByParam = this.route.snapshot.paramMap.get('id');
    //si on recoit un ID par la route, on va instancier le composant actuel
    if (MyPicklistIdByParam) {
      this.currentItem = new PickListDetail();
      this.currentItem.PickListDetailId = +MyPicklistIdByParam;
    }
  }

  //méthode permettant de rafraichir les données actuelle
  refreshInterface() {
    //var id = this.route.snapshot.paramMap.get('id');
    if (this.currentItem) {
      // EDIT
      this.titre = 'Modifier une ligne de PickList';
      // fetch project data
      this.myMainService.getDetail(this.currentItem.PickListDetailId).subscribe((jsonData) => {
        this.currentItem = jsonData;
      });
    } else {
      // ADD
      this.currentItem = new PickListDetail();
      this.titre = 'Créer une nouvelle PickList';
    }
  }

  //Evenement de sauvegarde...on encapsule pour gérer si on doit faire un pop-up ou non
  OnSauvegardeClick() {
    //si le formulaire est invalide [des champs required qui sont vides], on va demander à l'usager de confirmer
    if (this.myform.valid === false) {
      // pop dialog
      const dialogRef = this.dialog.open(PopConfirmComponent, {
        data: {
          titre: 'Formulaire avec champ invalide',
          texte: 'Attention!  Certains champs obligatoires ne semblent pas avoir été remplit. <br/><br/>Désirez-vous enregistrer QUAND MÊME?',
          affirmativeActionName: 'Oui, enregistrer quand même',
          affirmativeActionColor: 'primary',

          dismissiveActionName: 'Non, revenir en arrière',
          dismissiveActionColor: 'warn',
        },
      });
      // after close dialog
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.sauvegarder();
        }
      });
    } else {
      //si le modèle était valide dès le début, on enregistre.
      this.sauvegarder();
    }
  }

  //méthode pour enregistrer dans la bd
  sauvegarder() {
    let action = 'sauvegardé';
    //si le projet a un ID, c'estun UPDATe...
    if (this.currentItem.PickListDetailId) {
      // EDIT
      this.myMainService.updateDetail(this.currentItem).subscribe((jsonData) => {
        //on ferme le FORM
        this.cacherForm(true);
        //pop-up...
        this.snack.open('Le taux a été ' + action + '.', '', { duration: 3000 });
        this.IsChangesPublished = true;
      });
      /*Le Header Des Picklist n'est pas éditable après sa création*/
    } else {
      // On ne peut pas créer un détail
      // ADD
      /*this.myMainService.create(this.currentItem.NumberOfSplits, this.currentItem.OutputType)
      .subscribe((jsonData) => {
        this.currentItem = jsonData;
        action = 'ajoutée';
        
        //on ferme le FORM
        this.cacherForm(true);
        //pop-up...
        this.snack.open('La PickList a été ' + action + '.', '', { duration: 3000 });
        this.IsChangesPublished = true;
      });*/
    }
  }

  detruire() {
    // pop dialog
    /*const dialogRef = this.dialog.open(PopConfirmComponent, {
     data: {
       titre: 'Supprimer la station',
       texte: 'Êtes-vous sûr de vouloir supprimer ce type de paquet?',
       affirmativeActionName:'Supprimer',
       affirmativeActionColor:'warn',

       dismissiveActionName:'Annuler',
       dismissiveActionColor:'',
     },
   });
   // after close dialog
   dialogRef.afterClosed().subscribe((result) => {
     if (result === true) {
       //si on répond OUI, (affirmative)  on procède à la suppression
        this.myMainService.delete(this.currentItem.id).subscribe((jsonData) => {
          this.cacherForm(true);
          this.snack.open('Le type de paquet a été détruit.', '', { duration: 3000 });
          this.IsChangesPublished = true;
       });
     }
   });*/
    /*On ne peut pas détruire une PickList*/
  }

  annuler() {
    this.cacherForm();
  }

  cacherForm(param_ForceParentRefresh: boolean = false): void {
    this.submitEmitterChildHaveChanges.emit(false); //on raise le event indiquant si l'enfant a des changements en cours (false, ici)
    this.submitEmitterCanCloseChildForm.emit(true); //on raise le Event permettant de demander de se faire fermer
    this.submitEmitterForceRefresh.emit(param_ForceParentRefresh);
  }

  //Détecte N'IMPORTE quel changement sur mon composant
  ngDoCheck(changes: any) {
    let test = changes;

    if (this.myform?.pristine === false && this.IsChangesPublished === false) {
      this.IsChangesPublished = true;
      this.submitEmitterChildHaveChanges.emit(true);
    }
  }

  //ne détecte QUE les changements sur les @input values
  ngOnChanges() {
    this.refreshInterface();
  }
}
